// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface Parameter {
    productQty?: string;
}

type HandlerType = Handler<Parameter>;

export const OpenPartFinderModal: HandlerType = props => {
    if (props.parameter.productQty) {
        props.dispatch({
            type: "Store/Components/PartFinder/OpenPartFinderModal",
            productQty: props.parameter.productQty,
        });
    }
};

export const chain = [OpenPartFinderModal];

const openPartFinderModal = createHandlerChainRunnerOptionalParameter(chain, {}, "OpenPartFinderModal");
export default openPartFinderModal;
